import { DashboardGetStudentExitSlipQuery$data } from '../graphQLOperations/__generated__/DashboardGetStudentExitSlipQuery.graphql';
import { ExitSlipData } from '../models/ExitSlip';

type ClassExitSlips = DashboardGetStudentExitSlipQuery$data['classExitSlips'];

export const getStudentPendingExitSlips = (classExitSlips: ClassExitSlips): ExitSlipData[] =>
  (classExitSlips ?? [])
    .filter(
      slip =>
        slip.curriculumLesson?.hasExitSlip && !slip.learnosityExitSlipSessions?.some(session => session?.isComplete),
    )
    .map(slip => {
      const session = slip.learnosityExitSlipSessions?.[0];
      const skill = slip.curriculumLesson?.skills?.[0];
      return {
        id: slip.id,
        learnosityExitSlipSessions: session
          ? {
              activityId: session.activityId ?? '',
              id: session.id,
              isComplete: session.isComplete,
              publicUserId: session.publicUserId ?? '',
            }
          : null,
        curriculumLesson: {
          id: slip.curriculumLesson?.id ?? '',
          number: slip.curriculumLesson?.number ?? '',
          name: slip.curriculumLesson?.name ?? '',
          hasExitSlip: slip.curriculumLesson?.hasExitSlip ?? false,
          skill: skill ? { id: skill.id, code: skill.code ?? '', name: skill.name ?? '' } : null,
        },
      };
    });
